import service from '@/utils/request';

/**
 * 获取供应商列表
 * @param {Object} params - 查询参数
 * @param {string} params.keyword - 搜索关键词
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页条数
 * @returns {Promise}
 */
export function getSuppliers(params) {
  return service.get('/uic-system/supplier/pageGtZero', {
    params: {
      supplierName: params.keyword || '',
      current: params.current || 1,
      size: params.size || 20
    }
  });
}

/**
 * 获取仓库列表
 * @param {Object} params - 查询参数
 * @param {string} params.keyword - 搜索关键词
 * @returns {Promise}
 */
export function getWarehouses(params) {
  return service.get('/uic-system/ware/page', {
    params: {
      current: params.current || 1,
      size: params.size || 20,
      bizDept: params.bizDept || '',
      wareType: 0,
      wareName: params.keyword || ''
    }
  });
}

/**
 * 获取库位列表
 * @param {Object} params - 查询参数
 * @param {string} params.keyword - 搜索关键词
 * @param {string} params.warehouseId - 仓库ID (作为parentId传递)
 * @returns {Promise}
 */
export function getLocations(params) {
  return service.get('/uic-system/ware/page', {
    params: {
      parentId: params.warehouseId || '',
      wareType: 2,
      current: params.current || 1,
      size: params.size || 20,
      wareName: params.keyword || ''
    }
  });
}

/**
 * 获取物料列表
 * @param {Object} params - 查询参数
 * @param {string} params.supplierId - 供应商ID
 * @param {string} params.storeId - 仓库ID
 * @param {number} params.isBad - 是否不良品(0:正常,1:不良)
 * @param {number} params.current - 页码
 * @param {number} params.size - 每页条数
 * @returns {Promise}
 */
export function getMaterials(params) {
  return service.get('/api/uic-system/material/page', {
    params: {
      current: params.current || 1,
      size: params.size || 20,
      supplierId: params.supplierId || '',
      storeId: params.storeId || '',
      isBad: params.isBad || 0
    }
  });
}

/**
 * 获取托盘码列表
 * @param {Object} params - 查询参数
 * @param {string} params.palletCode - 托盘码关键词
 * @param {number} params.current - 页码
 * @param {number} params.size - 每页条数
 * @returns {Promise}
 */
export function getPalletCodes(params) {
  return service.get('/api/uic-system/palletcode/page', {
    params: {
      palletCode: params.palletCode || '',
      current: params.current || 1,
      size: params.size || 20
    }
  });
}

/**
 * 保存物料入库记录
 * @param {Object} data - 入库数据
 * @param {string} data.wareInType - 入库类型
 * @param {string} data.storeId - 仓库ID
 * @param {string} data.supplierId - 供应商ID
 * @param {string} data.supplierName - 供应商名称
 * @param {Array} data.wareInDetailList - 入库物料明细
 * @returns {Promise}
 */
export function saveStockIn(data) {
  return service.post('/uic-system_hf/warein/submit', data);
}

/**
 * 扫码入库提交
 * @param {Object} data - 扫码入库数据
 * @returns {Promise}
 */
export function saveScanStockIn(data) {
  return service.post('/uic-system/warein/scan-submit', data);
}

/**
 * 批量提交入库数据
 * @param {Array} data - 入库数据列表
 * @returns {Promise}
 */
// export function saveBatchStockIn(data) {
//   return service.post('/api/uic-system/warein/batch-submit', {
//     wareInType: "0", // 默认入库类型
//     wareInDetailList: data.map(item => ({
//       materialNo: item.materialNo,
//       wareInNum: item.wareInNum,
//       supplierCode: item.supplierCode,
//       batchNo: item.batchNo,
//       // 根据后端要求补充其他必要字段
//     }))
//   });
// }

/**
 * 通过编码查询供应商
 * @param {string} code - 供应商编码
 * @returns {Promise}
 */
export function getSupplierByCode(code) {
  return service.get('/uic-system/supplier/page', {
    params: {
      current: 1,
      size: 20,
      supplierCode: code
    }
  });
}

// 添加物料查询接口
export function getMaterialBySupplierAndNo(materialNo, supplierId) {
  return service.get('/uic-system_hf/material/page', {
    params: {
      materialNo,
      supplierId,
      type: 1,
      current: 1,
      size: 20,
      isCompose: 0
    }
  });
}

/**
 * 入库单分发接口（POST+查询参数正确实现）
 * @param {string} ids - 入库单ID字符串
 * @returns {Promise}
 */
export function distributeStockIn(ids) {
  // 修正：POST请求需显式传递空请求体+查询参数配置
  return service.post('/uic-system/warein/distribute', {}, {
    params: {
      ids: ids  // 会自动转为 ?ids=xxx 格式
    }
  });
}

// 在文件末尾添加
/**
 * 入库单收集接口
 * @param {Object} data - 收集数据
 * @param {string} data.wareInId - 入库单ID
 * @param {string} data.materialId - 物料ID
 * @param {string} data.materialGroupId - 物料组ID
 * @param {number} data.type - 类型
 * @param {Array} data.wareInDetailRecordVOList - 入库明细记录列表
 * @returns {Promise}
 */
export function collectStockIn(data) {
  return service.post('/uic-system/api_hf/warein/collect', data);
}

// 确保URL不包含重复的/api前缀
export function confirmCollect(data) {
  return service.post('/uic-system/api_hf/warein/collect/confirm', data);
}

// 添加物料存在性检查接口
export function checkMaterialExists(params) {
  return service.get('/uic-system_hf/materialstockdetail/getStockDetailListByMaterialId', {
    params: {
      materialId: params.materialId,
      batchNo: params.batchNo,
      current: 1,
      size: 1 // 只需要检查是否存在，查询1条即可
    }
  });
}

/**
 * 批量查询入库状态
 * @param {Array} batchIds - 批次ID列表
 * @returns {Promise}
 */
export function batchQueryStockInStatus(batchIds) {
  return service.get('/uic-system/warein/batch-status', {
    params: {
      batchIds: batchIds.join(',')
    }
  });
}

/**
 * 根据物料ID查询库位信息
 * @param {Object} params - 查询参数
 * @param {string} params.materialId - 物料ID
 * @param {string} params.materialNo - 物料编码（可选）
 * @param {number} params.current - 页码
 * @param {number} params.size - 每页条数
 * @returns {Promise}
 */
export function queryStockLocationByMaterialId(params) {
  return service.get('/uic-system/hf_materialstock/page', {
    params: {
      materialId: params.materialId,
      materialNo: params.materialNo || '',
      current: params.current || 1,
      size: params.size || 20
    }
  });
}